/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'well-collapsible-text',
  templateUrl: './collapsible-text.component.html',
  styleUrls: ['./collapsible-text.component.scss']
})
export class CollapsibleTextComponent implements OnInit {

  @Input() content: string | undefined = undefined;
  @Input() minLength: number = null;
  @Input() textClass: string | undefined = undefined;

  collapsed = true;
  collapsable = true;

  ngOnInit() {
    if(!this.minLength || !this.content || this.content.length <= this.minLength){
      this.collapsable = false;
    }

  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

}
